import memoize from 'memoize-one';
import {MovingAverageChartData} from 'views/storyboard/utils/calculations/chartMovingAverage';
import {LinearRegressionChartData} from 'views/storyboard/utils/calculations/chartLinearRegression';


type ChartDatapointMeansData = (
    MovingAverageChartData | LinearRegressionChartData
);

export const getChartDatapointMeans = memoize(
    // Calculates the total for every key for every data point and adds it together and divides by the number of keys
    (
        data: ChartDatapointMeansData[],
        dataKeys: string[],
        excludedKeys: string[] = [],
    ): number[] => {
        const usingKeys = dataKeys.filter((key) => !excludedKeys.includes(key));
        return data.map((el) => usingKeys.reduce(
            (keyAccumulator, keyCurrentValue) => keyAccumulator + (
                (el?.[keyCurrentValue as keyof ChartDatapointMeansData] as number | null) || 0), 0,
        ) / usingKeys.length);
    },
);
